module.exports = __webpack_public_path__ + "img/16581283_L.7dd83a00.png";